import { TJobWorkingTime } from "@/features/job/types/JobForm";

const timeToMinutes = (timeString: string) => {
  if (!timeString || timeString === "") return 0;
  const [hours, minutes, _] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

export const calculationWorkingTime = (jobWorkingTime: TJobWorkingTime[]) => {
  return jobWorkingTime.map((workingTime: TJobWorkingTime) => {
    return calculateWorkingTimeItem(workingTime);
  });
};

export const calculateWorkingTimeItem = (workingTime: TJobWorkingTime) => {
  if (!workingTime.workingTimeStart || !workingTime.workingTimeEnd) {
    return {
      hours: 0,
      minutes: 0,
    };
  }
  const startMinutes = timeToMinutes(workingTime.workingTimeStart);
  let endMinutes = timeToMinutes(workingTime.workingTimeEnd);
  const breakMinutes = Number(workingTime.workingTimeBreakTime);

  if (endMinutes < startMinutes) {
    endMinutes += 24 * 60;
  }

  const totalMinutes = endMinutes - startMinutes - breakMinutes;

  if (totalMinutes < 0 || isNaN(totalMinutes)) {
    return {
      hours: 0,
      minutes: 0,
    };
  }

  const hours = Math.floor(totalMinutes / 60);
  if (hours < 0) {
    return {
      hours: 0,
      minutes: 0,
    };
  }
  const minutes = totalMinutes % 60;

  return {
    hours: hours,
    minutes: minutes,
  };
};
